'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.externalServices = void 0;
var adapter_1 = require("../adapter");
var ExternalServices = /** @class */ (function () {
    function ExternalServices() {
    }
    /**
     * Get the token for the chat
     */
    ExternalServices.prototype.getChatToken = function (params) {
        return adapter_1.adapter.externalServices.getChatToken(params);
    };
    /**
     * Depending on the passed params it:
     * gets the token used to load the contest general service
     * gets the token for simplify notifications
     * gets the token for Pool Bets
     * gets the token for Betsson PAAS cashier or PAAS KYC
     */
    ExternalServices.prototype.requestToken = function (params) {
        return adapter_1.adapter.externalServices.requestToken(params);
    };
    ExternalServices.prototype.getSessionHash = function () {
        return adapter_1.adapter.externalServices.getSessionHash();
    };
    ExternalServices.prototype.getIntercomToken = function () {
        return adapter_1.adapter.externalServices.getIntercomToken();
    };
    return ExternalServices;
}());
exports.externalServices = new ExternalServices();
